import { Component, OnInit } from '@angular/core';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import * as moment from "moment"
import { StudentPortalService } from 'src/app/services/StudentPortal/student-portal.service';

@Component({
  selector: 'app-studenthomework',
  templateUrl: './studenthomework.component.html',
  styleUrls: ['./studenthomework.component.css']
})
export class StudenthomeworkComponent implements OnInit {

  constructor(private studentPortalService: StudentPortalService, private spinnerService: Ng4LoadingSpinnerService, private lookupService: LookupService, public globalHelper: GlobalHelper) { }


HomeWorkModel = {
  HomeWorkID: 0,
  StudentHomeworkID: 0,
  ClassID: 0,
  SectionID: 0,
  CourseID: 0,
  StudentID: 0,
  AssignmentTypeID: 0,
  AssignmentDate: '',
  SubmissionDate: '',
  HomeWorkTitle: '',
  Description: '',
  IsActive: true,
  TearcherComment: '',  
  StudentComment: '',
  StudentHomeworkPath: '',
 
};
SelectFileUpload:any;
selectFileUpload  (file) {

    this.SelectFileUpload = file[0];

    if (this.SelectFileUpload != null) {
        this.HomeWorkModel.StudentHomeworkPath = '';
    }
};

 ValidateDropdown() {
    return this.HomeWorkModel.StudentHomeworkPath == null || this.HomeWorkModel.StudentComment == null
    

};
Submitted = false;
SaveStudentHomeWork  () {

    this.Submitted = true;
    if (!this.ValidateDropdown()) {
        
        this.studentPortalService.SaveStudentHomeWork(JSON.stringify(this.HomeWorkModel), this.SelectFileUpload).subscribe((response: any) => {
            
                this.GetStudentHomeWork();
           
            this.Clear();

            this.globalHelper.CheckActionStatus(response);

        });
    }
}


Clear  () {
    this.Submitted = false;
    // uploadFile = $('#fileUpload');
    // uploadFile.replaceWith(uploadFile = uploadFile.clone(true));
    this.HomeWorkModel.HomeWorkID = 0;
    this.HomeWorkModel.StudentID = 0;
    this.HomeWorkModel.ClassID = 0;
    this.HomeWorkModel.CourseID = 0;
    this.HomeWorkModel.SectionID = 0;
    this.HomeWorkModel.AssignmentTypeID = 0;
    this.HomeWorkModel.StudentComment = '';
    this.HomeWorkModel.SubmissionDate = '';
    this.HomeWorkModel.HomeWorkTitle = '';
 

}
StudentHomeWorkList:any;
GetStudentHomeWork  () {
    this.studentPortalService.GetStudentHomeWork().subscribe((response: any) => {
        this.StudentHomeWorkList = response.StudentHomeWorkList;
        this.globalHelper.CheckActionStatus(response);
       
    });
};

StudentHomeWorkFileList:any;
GetStudentHomeWorkFile  () {
    this.studentPortalService.GetStudentHomeWorkFile(JSON.stringify( this.HomeWorkModel)).subscribe((response: any) => {
        this.StudentHomeWorkFileList = response.StudentHomeWorkFileList;
        this.globalHelper.CheckActionStatus(response);
       
    });
};
SetHomeworkID  (obj) {

  this.HomeWorkModel.HomeWorkID = obj.HomeWorkID;
  this.HomeWorkModel.ClassID = obj.ClassID;
  this.HomeWorkModel.SectionID = obj.SectionID;
  this.HomeWorkModel.StudentHomeworkID = obj.StudentHomeworkID;
  this.HomeWorkModel.StudentComment = obj.StudentComment;
  this.HomeWorkModel.StudentHomeworkPath = obj.StudentHomeworkPath;
  this.GetStudentHomeWorkFile();
}
SetID  (obj) {

    this.HomeWorkModel.HomeWorkID = obj.HomeWorkID;
    this.HomeWorkModel.ClassID = obj.ClassID;
    this.HomeWorkModel.SectionID = obj.SectionID;
    this.HomeWorkModel.StudentHomeworkID = obj.StudentHomeworkID;
    this.HomeWorkModel.StudentComment = obj.StudentComment;
    this.HomeWorkModel.StudentHomeworkPath = obj.StudentHomeworkPath;
    
}



  ngOnInit() {
    this.GetStudentHomeWork();
  }

}
